/* INJECT_TYPE */
export * as productGallery from './productGallery'
export * as aboutHero from './aboutHero'
export * as lifestyleGallery from './lifestyleGallery'
export * as homeProductList from './homeProductList'
export * as fourOhFour from './fourOhFour'
